const DEFAULT_AFFINE_NAME = 'AFFiNE';
const DEFAULT_AFFINE_LOGO_URL = '/assets/affine-favicon.png';
const DEFAULT_AFFINE_FAVICON_URL = '/assets/affine-favicon.png';

export const serverBrandingQuery =
  '{ serverConfig { name subtitle logoUrl faviconUrl } }';

export function isSafeBrandingUrl(value: unknown): value is string {
  if (typeof value !== 'string' || !value.trim()) {
    return false;
  }

  const url = value.trim();
  if (url.startsWith('/') && !url.startsWith('//')) {
    return true;
  }

  try {
    return new URL(url).protocol === 'https:';
  } catch {
    return false;
  }
}

type ServerBrandingConfig = {
  name?: unknown;
  subtitle?: unknown;
  logoUrl?: unknown;
  faviconUrl?: unknown;
};

export type InstanceBranding = {
  name: string;
  subtitle?: string;
  logoUrl: string;
  fallbackLogoUrl: string;
  faviconUrl: string;
};

export function getInstanceBranding(
  configured?: ServerBrandingConfig,
  isSelfHosted = false
): InstanceBranding {
  const configuredName =
    typeof configured?.name === 'string' ? configured.name.trim() : '';
  const configuredSubtitle =
    typeof configured?.subtitle === 'string' ? configured.subtitle.trim() : '';
  const name =
    configuredName && !(isSelfHosted && configuredName === 'AFFiNE Self-hosted')
      ? configuredName
      : DEFAULT_AFFINE_NAME;

  return {
    name,
    subtitle: configuredSubtitle || undefined,
    logoUrl: isSafeBrandingUrl(configured?.logoUrl)
      ? configured.logoUrl.trim()
      : DEFAULT_AFFINE_LOGO_URL,
    fallbackLogoUrl: DEFAULT_AFFINE_LOGO_URL,
    faviconUrl: isSafeBrandingUrl(configured?.faviconUrl)
      ? configured.faviconUrl.trim()
      : DEFAULT_AFFINE_FAVICON_URL,
  };
}
